import { render, staticRenderFns } from "./AppointmentPaymentDialogContent.vue?vue&type=template&id=00485f82"
import script from "./AppointmentPaymentDialogContent.vue?vue&type=script&lang=ts"
export * from "./AppointmentPaymentDialogContent.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentPaymentDialogContent.vue?vue&type=style&index=0&id=00485f82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports